import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil } from "@fortawesome/free-solid-svg-icons";
import { Form } from "react-bootstrap";
import Pagination_Holder from "../../../../../common/common_components/pagination_holder/Pagination_Holder";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Delete,
  GetAll,
  StatusRole,
} from "../../../../../features/admin/role_permmission/role/Slice";
import { FixIDS } from "../../../../../utils/fixIDS";
const Table = ({ setEdit, setEditId, searchName }) => {
  const alldata = useSelector((state) => state.usermanagement.roles);
  console.log("alldataalldata", alldata.data);
  const dispatch = useDispatch();
  const permissions = useSelector((state) => state.auth.permissions);
  const haveEditPermission = permissions?.includes(FixIDS.Roles.Edit);
  const haveDeletePermission = permissions?.includes(FixIDS.Roles.Delete);

  const [onPageChange, setonPageChange] = useState(1);

  useEffect(() => {
    fetch(onPageChange);
  }, [searchName, onPageChange]);

  const fetch = async (page = 1) => {
    console.log("searchNamesearchName", searchName);
    await dispatch(
      GetAll({
        name: searchName,
        page: page,
        per_page: alldata?.per_page,
      }),
    );
  };

  const handlePageChange = (page) => {
    setonPageChange(page);
  };

  const getStatusClass = (status) => {
    if (status === true || status === "true" || status === 1) return "green";
    if (status === false || status === "false" || status === 0) return "red";
    return "";
  };

  return (
    <>
      <div className="common_table_container theme_bg">
        <div className="table-responsive">
          <table className="common_table table table-striped">
            <thead>
              <tr>
                <th>Sr. No</th>
                <th>Date</th>
                <th>Role Name</th>
                <th>Role Description</th>
                <th>Status</th>

                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {alldata?.data.map((row, index) => (
                <tr key={index} className={index % 2 !== 0 ? "striped" : ""}>
                  <td>
                    {(alldata?.current_page - 1) * alldata?.per_page +
                      index +
                      1}
                  </td>
                  <td>
                    {row.createdAt
                      ? new Date(row.createdAt).toLocaleDateString("en-IN")
                      : "-"}
                  </td>

                  <td>{row.name}</td>
                  <td>{row.description}</td>
                  <td className={`status ${getStatusClass(row.status)}`}>
                    {row.status === true || row.status === "true"
                      ? "Active"
                      : "Inactive"}
                  </td>

                  <td>
                    {haveEditPermission && (
                      <div
                        className="edit_icon_holder"
                        onClick={() => {
                          setEdit(true);
                          setEditId(row.id);
                        }}
                      >
                        <FontAwesomeIcon
                          icon={faPencil}
                          className="edit_icon"
                        />
                      </div>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className="comon_page_footer">
        <div className="show_entry_div">
          <p className="show_text">
            Showing {(alldata?.current_page - 1) * alldata?.per_page + 1} To{" "}
            {Math.min(
              alldata?.current_page * alldata?.per_page,
              alldata?.total,
            )}{" "}
            Of {alldata?.total} Entries
          </p>
        </div>

        <div className="pagination_div">
          <Pagination_Holder
            onPageChange={alldata?.current_page}
            totalPages={alldata?.total_pages}
            handlePageChange={handlePageChange}
          />
        </div>
      </div>
    </>
  );
};

export default Table;
